import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Processo from "../pages/processo/page";
import Dashboard from "../pages/dashboard/page";
import Pastas from "../pages/pastas/page";
import PastaDetalhe from "../pages/pastas/detalhe/page";
import Kanban from "../pages/kanban/page";
import CadastroClientes from "../pages/cadastro-clientes/page";
import Comercial from "../pages/comercial/page";
import Marketing from "../pages/marketing/page";
import Parametros from "../pages/parametros/page";
import Usuarios from "../pages/usuarios/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/processo",
    element: <Processo />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/habita",
    element: <Dashboard />,
  },
  {
    path: "/pastas",
    element: <Pastas />,
  },
  {
    path: "/habita/pastas",
    element: <Pastas />,
  },
  {
    path: "/pastas/:id",
    element: <PastaDetalhe />,
  },
  {
    path: "/habita/cliente/:idProcesso",
    element: <PastaDetalhe />,
  },
  {
    path: "/kanban",
    element: <Kanban />,
  },
  {
    path: "/habita/kanban",
    element: <Kanban />,
  },
  {
    path: "/marketing",
    element: <Marketing />,
  },
  {
    path: "/habita/marketing",
    element: <Marketing />,
  },
  {
    path: "/comercial",
    element: <Comercial />,
  },
  {
    path: "/habita/comercial",
    element: <Comercial />,
  },
  {
    path: "/usuarios",
    element: <Usuarios />,
  },
  {
    path: "/habita/usuarios",
    element: <Usuarios />,
  },
  {
    path: "/parametros",
    element: <Parametros />,
  },
  {
    path: "/habita/parametros",
    element: <Parametros />,
  },
  {
    path: "/cadastro-clientes",
    element: <CadastroClientes />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
